import React from "react";
import styled from "styled-components";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";

import { MainHeadingWrapper } from "../../Elements/Elements";
import ProjectCard from "./ProjectCard";
import ProjectDetail from "./ProjectDetail";
import monkey from "../../Images/monkey.PNG";
// import pexel from "../../Images/pexel.PNG"
import flipkart from "../../Images/flipkart.PNG";
import bewakoof from "../../Images/bewakoof.jpeg";
import pluralsight from "../../Images/pluralsight.jpeg";
// import { bewakoof } from '.';
const useStyles = makeStyles((theme) => ({
  root: {
    overflowY: "scroll",
    padding: "100px 0 ",
  },
}));

const BridgeTwo = styled.div`
  padding-top: 150px;
  width: 100%;
  margin: 0 auto;
  background-color: ${(props) => props.theme.body};
  color: ${(props) => props.theme.fontColor};

  /* min-height: 400px; */
  z-index: 99;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  > div:nth-child(2) {
    padding: 50px 0;
    border-radius: 5px;
    display: flex;
    flex-wrap: wrap;
    grid-row-gap: 20px;
    width: 90%;
    margin: 30px auto;
    align-items: center;
    justify-content: space-evenly;
    background-size: cover;
    background-position: center;
  }
`;

let projectArray = [
  {
    img: monkey,
    title: "Survey Monkey Clone ",
    description:
      "A global leader in survey software. 20 million questions answered daily.",
    techStack: ["React", "CSS", "JavaScript"],
    repoLink: "https://github.com/Ace0012/smooth-dock-1057",
    demoLink: "https://topsurvey.vercel.app/",

    blogLink: "#",
    features: [
      "Landing page for Monkey Survey",
      "Login and Signup for the user account",
      "Password stored in hashed form (user privacy)",
      " Display all surveys and surveys created by the user",
    ],
  },
  {
    img: flipkart,
    title: "Flipkart Clone",
    description:
      "Flipkart is one of India's leading E-commerce marketplaces and is headquartered in Bengaluru. The company initially started as an online bookstore.",
    techStack: ["React", "CSS", "JavaScript"],
    repoLink: "https://github.com/Ace0012/Flipkart-Clone-Project",
    demoLink: "https://famous-babka-3b2c52.netlify.app",

    blogLink: "#",
    features: [
      "User Authentication",
      "Products Gallery",
      "Product Filtering",
      "Product Caraousl",
      "Product Buying",
      "User Cart",
      "Checkout",
    ],
  },
  {
    img: bewakoof,
    title: "Bewakoof Clone",
    description:
      " Bewakoof is a lifestyle fashion brand that makes creative, distinctive fashion for the trendy, contemporary Indian. Bewakoof was created on the principle of creating impact through innovation, honesty and thoughtfulness",
    techStack: ["HTML", "CSS", "JavaScript"],

    repoLink: "https://github.com/Ace0012/bewakoof.com",
    demoLink: "https://coruscating-pasca-28b729.netlify.app/",

    blogLink: "#",
    features: [
      "Sign In ",
      "Mens Page ",
      "Womens Page",
      "Mobile Page",
      "Mega Drop Down Menu",
    ],
  },
  {
    img: pluralsight,
    title: "Pluarlsight Clone",
    description:
      "Pluralsight Skills is the technology skills platform that allows you to measure and evolve the skills you need now. You'll discover which skills you need to succeed, where your skill gaps exist, and what you need to work on to reach role mastery.",
    techStack: ["HTML", "CSS", "JavaScript"],

    repoLink: "https://github.com/Ace0012/pluralsightClone",
    demoLink: "https://gifted-lumiere-359384.netlify.app/",

    blogLink: "#",
    features: [
      "Sign In ",
      "Mens Page ",
      "Womens Page",
      "Mobile Page",
      "Mega Drop Down Menu",
    ],
  },
];

function Projects() {
  const [panel, setPanel] = React.useState(false);
  let [currentProject, setCurrentProject] = React.useState({});
  const classes = useStyles();
  return (
    <div id="projects">
      <BridgeTwo backgroundImg={currentProject.img}>
        <MainHeadingWrapper>
          <h1>Projects</h1>
          <div></div>
        </MainHeadingWrapper>
        <div>
          {projectArray?.map((project) => (
            <ProjectCard
              key={project.title}
              setCurrentProject={setCurrentProject}
              setPanel={setPanel}
              {...project}
            ></ProjectCard>
          ))}
        </div>
        <Modal
          className={classes.root}
          open={panel}
          onClose={() => setPanel(false)}
        >
          <ProjectDetail
            {...currentProject}
            setPanel={setPanel}
          ></ProjectDetail>
        </Modal>
      </BridgeTwo>
    </div>
  );
}

export default Projects;
